import { Clickable, Col, Row, Shoutout, ShoutoutsPage, Text } from 'components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Shoutouts = ({ user }) => {
  const [data, setData] = useState([]),
    [showPage, setShowPage] = useState(false),
    { t } = useTranslation(),
    isMobile = useSelector((state) => state.appState.isMobile);

  useEffect(() => {
    setData(user.type === 'fan' ? user.sentShoutouts : user.shoutouts);
  }, [user]);

  if (isMobile || !data?.length) return null;

  return (
    <React.Fragment>
      <ShoutoutsPage visible={showPage} setVisible={setShowPage} data={data} user={user} />

      <Col wid="100%">
        <Row between wid="100%">
          <Text h2>{t('profile.recentShoutouts')}</Text>

          <Clickable marg="17px 0 0" onClick={() => setShowPage(!showPage)}>
            <Text b2 bold>
              {t('common.seeAll')}
            </Text>
          </Clickable>
        </Row>

        <Row marg="18px 0 0" gap="24px" start>
          {data.slice(0, 3).map((x) => (
            <Shoutout item={x} user={user} />
          ))}
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default Shoutouts;
